import Recipes from "./modules/recipes";
import Miku from "./modules/miku";

export const mikuKzStores = { Recipes, Miku };
